import { useTranslate } from "@similarweb/i18n-provider";

import { MetricWidgetChart } from "../../common/widget/donut-metric/MetricWidgetChart";
import { MetricWidgetContainer } from "../../common/widget/donut-metric/MetricWidgetContainer";
import { MetricWidgetModal } from "../../common/widget/donut-metric/MetricWidgetModal";
import { MetricWidgetProvider } from "../../common/widget/donut-metric/MetricWidgetProvider";

import { ShareMetricLegend } from "./shared/ShareMetricLegend";
import { ShareMetricTable } from "./shared/ShareMetricTable";
import { useShareMetricQuery } from "./shared/useShareMetricQuery";

export const ShareOfViews = () => {
    const { translate } = useTranslate();
    const {
        data: chartData,
        isLoading,
        isFetching,
        isError,
    } = useShareMetricQuery("activationAlertsMetricsSocialMediaShareOfViewsDetail");

    return (
        <MetricWidgetProvider
            chartData={chartData}
            isLoading={isLoading || isFetching}
            isError={isError}
        >
            <MetricWidgetContainer
                title={translate("activation.alerts.social-media.metrics.share-of-views.title")}
                automationId="share-of-views-metrics-widget"
                seeAllAutomationId="see-all-share-of-views-button"
            >
                <MetricWidgetChart>
                    <ShareMetricLegend
                        dataAutomation="share-of-views-metrics-legend"
                        shareDataAutomation="share-of-views-legend-share"
                    />
                </MetricWidgetChart>
            </MetricWidgetContainer>
            <MetricWidgetModal
                title={translate("activation.alerts.social-media.metrics.share-of-views.title")}
                automationId="all-share-of-views-modal"
            >
                <ShareMetricTable />
            </MetricWidgetModal>
        </MetricWidgetProvider>
    );
};
